export default __webpack_public_path__ + "static/media/img_10.bab1e96e.JPG";